/**
 * HannoNexus Solar — official brand mark.
 *
 * Uses the officially provided hexagonal HX shield PNG (sun + solar-panel base).
 * The same API is preserved (`size`, `className`) so all existing call-sites
 * across the site continue to work.
 *
 * For the full HannoNexus wordmark + SOLAR tagline lockup use <HannoLockup />.
 */
import React from "react";

const MARK_SRC = "/hanno/branding/logo-mark-alpha.png";

export const HannoMark = ({ size = 40, className = "", ...rest }) => {
  // Original mark aspect is ~120x115 → nearly square, render as square box.
  return (
    <img
      src={MARK_SRC}
      alt="HannoNexus Solar"
      width={size}
      height={size}
      loading="eager"
      decoding="async"
      draggable={false}
      className={`select-none ${className}`}
      style={{
        // Subtle drop shadow to give the mark depth on dark surfaces
        filter: "drop-shadow(0 2px 6px rgba(0,0,0,0.35))",
      }}
      data-testid="hanno-mark"
      {...rest}
    />
  );
};

/**
 * Full lockup: HX shield + "HannoNexus SOLAR" wordmark.
 * Ideal for hero areas, footer credits and press-kit downloads.
 */
export const HannoLockup = ({ height = 48, className = "", ...rest }) => {
  // Lockup aspect ~ 510x110 → width = height * (510/110) ≈ 4.64
  const width = Math.round(height * (510 / 110));
  return (
    <img
      src="/hanno/branding/logo-lockup-alpha.png"
      alt="HannoNexus Solar"
      width={width}
      height={height}
      loading="eager"
      decoding="async"
      draggable={false}
      className={`select-none ${className}`}
      style={{ filter: "drop-shadow(0 3px 10px rgba(0,0,0,0.35))" }}
      data-testid="hanno-lockup"
      {...rest}
    />
  );
};

export default HannoMark;
